import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../app/hooks";
import AcedSelect, {
	SelectOption,
} from "../../../components/essentials/input/select/AcedSelect";
import { selectUser, setUser } from "../../../core/auth/authSlice";
import { addErrorMessage } from "../../../core/errors/errorSlice";
import { MembersApiRoutes } from "../../../shared/api-routes/member/members-api.routes";
import { UtilsApiRoutes } from "../../../shared/api-routes/utils/utils.api-routes";
import { User } from "../../../shared/models";
import http from "../../../shared/utils/http";
import "./ChooseAccountType.scss";

const ChooseAccountType: React.FC = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const appDispatch = useAppDispatch();
	const { actorId } = useSelector(selectUser) as User;
	const { t } = useTranslation();

	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm({
		defaultValues: {
			selectedaccountType: "",
		},
	});

	const [accountTypeOptions, setAccountTypeOptions] = useState<SelectOption[]>(
		[]
	);

	useEffect(() => {
		http.get(UtilsApiRoutes.GET_ACCOUNT_TYPES).then((res) => {
			const types = res.filter((type: string) => type !== "team");
			const options = types.map((type: string) => ({
				value: type,
				label: t("profile.accountType.accountTypes." + type),
			}));
			setAccountTypeOptions(options);
		});
	}, [t]);

	const onSubmit = (data: any) => {
		const accountType = data.selectedaccountType;

		if (!accountType) {
			appDispatch(
				addErrorMessage({
					title: t(
						"profile.accountType.errors.required",
						"Please select an account type"
					),
				})
			);
			return;
		}

		http
			.patch(MembersApiRoutes.UPDATE_USER(actorId), {
				accountType: accountType,
			})
			.then(() => {
				dispatch(setUser({ accountType }));
				navigate("/info");
			})
			.catch((error) => {
				appDispatch(
					addErrorMessage({
						title: t(
							"profile.accountType.errors.generic",
							"Failed to update account type. Please try again."
						),
					})
				);
			});
	};

	return (
		<div className="sign-up-type">
			<p className="sign-up-type__caption">{t("profile.accountType.title")}</p>
			<p className="sign-up-type__subtitle">
				{t("profile.accountType.subtitle")}
			</p>

			<form
				id="choose-account-type-form"
				className="sign-up-type__form"
				onSubmit={handleSubmit(onSubmit)}
			>
				<AcedSelect
					control={control}
					options={accountTypeOptions}
					placeholder={t(
						"profile.accountType.placeholder",
						"Select account type"
					)}
					name="selectedaccountType"
					className="w-100"
					rules={{
						required: t(
							"profile.accountType.errors.required",
							"Please select an account type"
						),
					}}
				/>
			</form>
		</div>
	);
};

export default ChooseAccountType;
